// 1. Imports
import "./SwipeableModals.scss";
import React, { useEffect, useState } from "react";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import {
  CircularProgress,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import BlueButton from "../../../components/BlueButton/BlueButton";
import api from "../../../utils/api";
import { message } from "antd";

const SwipeableModals = ({
  open,
  onClose,
  onOpen,
  currentView,
  user,
  onDataChange,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [newUser, setNewUser] = useState(user);
  const [loading, setIsLoading] = useState(false);
  useEffect(() => {
    setNewUser(user);
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await api.put(`/users/${newUser.id}`, { ...newUser });
      onClose();
      message.success("تم تعديل المستخدم بنجاح");
      onDataChange();
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    setNewUser((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const renderChangePasswordView = () => (
    <div className="user-modal">
      <p className="user-modal-p">تعديل كلمة المرور</p>
      <form>
        <FormControl
          sx={{ width: "100%", borderRadius: "8px" }}
          variant="outlined"
        >
          <InputLabel
            htmlFor="outlined-adornment-password"
            sx={{
              left: "auto",
              background: "white",
              right: 12,
              transformOrigin: "right",
              "&:not(.MuiInputLabel-shrink)": {
                transform: "translate(-8px, 12px) scale(1)",
              },
              "&.MuiInputLabel-shrink": {
                transform: "translate(0, -10px) scale(0.8)",
              },
            }}
          >
            كلمة المرور الجديدة
          </InputLabel>
          <OutlinedInput
            required
            sx={{ borderRadius: "8px" }}
            id="outlined-adornment-password"
            type={showPassword ? "text" : "password"}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>

        <FormControl sx={{ width: "100%" }} variant="outlined">
          <InputLabel
            htmlFor="outlined-adornment-password"
            sx={{
              left: "auto",
              background: "white",
              right: 12,
              transformOrigin: "right",
              "&:not(.MuiInputLabel-shrink)": {
                transform: "translate(-8px, 12px) scale(1)",
              },
              "&.MuiInputLabel-shrink": {
                transform: "translate(0, -10px) scale(0.8)",
              },
            }}
          >
            تاكيد كلمة المرور
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="outlined-adornment-password"
            type={showPassword ? "text" : "password"}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>

        <BlueButton text="تاكيد" size="medium" variant="fill" />
      </form>
    </div>
  );

  const renderEditUserView = () => (
    <div className="user-modal">
      <p className="user-modal-p"> تعديل المستخدم</p>
      <form onSubmit={handleSubmit}>
        <FormControl sx={{ width: "100%" }} variant="outlined">
          <InputLabel
            htmlFor="outlined-adornment-password"
            shrink
            sx={{
              background: "white",
              transformOrigin: "right top",
              transform: "translate(14px, -9px) scale(0.8)",
              right: 24,
              left: "auto",
              paddingLeft: "4px",
              paddingRight: "4px",
            }}
          >
            الاسم
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="outlined-adornment-password"
            type="text"
            notched
            value={newUser?.name}
            onChange={handleChange}
            name="name"
          />
        </FormControl>

        <FormControl sx={{ width: "100%" }} variant="outlined">
          <InputLabel
            htmlFor="outlined-adornment-password"
            shrink
            sx={{
              background: "white",
              transformOrigin: "right top",
              transform: "translate(14px, -9px) scale(0.8)",
              right: 24,
              left: "auto",
              paddingLeft: "4px",
              paddingRight: "4px",
            }}
          >
            رقم الموبايل
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="outlined-adornment-password"
            type="text"
            notched
            value={newUser?.phone}
            onChange={handleChange}
            name="phone"
          />
        </FormControl>

        <FormControl sx={{ width: "100%" }} variant="outlined">
          <InputLabel
            htmlFor="outlined-adornment-password"
            shrink
            sx={{
              background: "white",
              transformOrigin: "right top",
              transform: "translate(14px, -9px) scale(0.8)",
              right: 24,
              left: "auto",
              paddingLeft: "4px",
              paddingRight: "4px",
            }}
          >
            البريد الالكتروني
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="outlined-adornment-password"
            type="email"
            notched
            value={newUser?.email}
            onChange={handleChange}
            name="email"
          />
        </FormControl>

        <BlueButton
          text={loading ? "" : "حفظ"}
          icon={
            loading ? (
              <CircularProgress
                color="success"
                className="circular-progress"
                size={24}
              />
            ) : (
              ""
            )
          }
          size="medium"
          variant="fill"
          loading={loading}
        />
      </form>
    </div>
  );

  const renderDefaultView = () => <div></div>;

  const views = {
    editUser: renderEditUserView,
    changePassword: renderChangePasswordView,
  };

  return (
    <SwipeableDrawer
      anchor="left"
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      sx={{ zIndex: "1202" }}
      disableScrollLock
    >
      {(views[currentView] || renderDefaultView)()}
    </SwipeableDrawer>
  );
};

export default SwipeableModals;
